export const LOSS_HISTORY = {
  LABEL: "Loss History Review",
  RESET: "qtc/losshistory/reset",
  TYPES: {
    PROVIDED: "provided",
    ADMITTED: "admitted",
    RETRIEVED: "retrieved",
    APPLIED: "applied"
  },
  COPY: {
    BUTTON: "Run Loss History Report",
    CARD: "Please make sure that all information provided in the quote is correct before running the loss history report. If you make changes after running the report, you will need to run it again.",
    INCOMPLETEQUOTE:
      "To run the loss history report, all required questions must be answered and you must have one eligible product.",
    PREWARNING:
      "Please note that running a loss history report indicates an intent to bind. Be sure that all information provided in the quote is correct before proceeding. Once you run a loss history, some fields in your quote will become disabled.",
    POSTWARNING:
      "Now that you've run loss history report, some fields in your quote are disabled",
    NORESULTS:
      "No retrieved or admitted losses were found. Please continue on to the next step.",
    REVIEWHEADING: "Please review your applied losses",
    REVIEWCOPY:
      "You may now continue onto the next step. If you believe there is an inaccuracy, refer your retrieved losses to underwriting below. Losses retrieved during the review are automatically applied to the quote.",
    PENDINGREFERRALBUTTON: "View Pending Referral",
    LASTMESSAGEFROMUNDERWRITING: "Last message from underwriting on "
  },
  TASK_STATUS: {
    APPROVED: "reconciled",
    COMPLETE: "complete",
    DECLINED: "declined",
    PENDING: null,
    WITHDRAWN: "withdrawn"
  },
  ACTION: {
    REFER_LOSS_BUTTON_CLICKED: "Quote Edit - Refer Loss Button Clicked",
    REFER_LOSS_LINK_CLICKED: "Quote Edit - Refer Loss Link Clicked",
    REFER_LOSS_LINK_RENDERED: "Quote Edit - Refer Loss Link Displayed"
  }
};
